import React from "react";
import Users from "../components/users/Users";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function UsersPage() {

  return (
    <div>
      <TitleUpdater />
      <Users />
    </div>
  );
}
